<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="title">
                Frequently Asked Questions
            </div>
            <v-spacer></v-spacer>
            <Button
                v-show="isAdmin"
                label="Manage"
                color="primary"
                cssClass="mr-2"
                @click="$router.push('/faqs/manage')"
            />
        </div>
        <v-expansion-panels v-if="faqs && faqs.length > 0" active-class="active-category">
            <v-expansion-panels>
                <v-expansion-panel
                    v-for="(faq, idx) in faqs"
                    :key="idx"
                >
                    <v-expansion-panel-header>
                        <strong>{{ faq.question }}</strong>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <template v-if="!(faq.split && faq.split.length > 0)">
                            {{ faq.answer }}
                        </template>
                        <template v-for="(item, idx) in faq.split">
                            <span v-if="item.type === 'string'" :key="idx">
                                {{ item.value }}
                            </span>
                            <span v-else-if="item.value.match(/retrack/)" :key="idx">
                                <v-btn
                                    color="primary"
                                    @click="handleRetrack"
                                    v-if="!loading"
                                >
                                    Send
                                </v-btn>
                                <v-progress-circular v-else indeterminate />
                            </span>
                            <span v-else-if="item.value.match(/add/)" :key="idx">
                                <v-btn
                                    color="primary"
                                    @click="$router.push({
                                        name: 'AddPack'
                                    })"
                                >
                                    Manage
                                </v-btn>
                            </span>
                        </template>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-expansion-panels>
        <v-progress-linear v-else-if="loading" indeterminate />
    </div>
</template>

<script>
import Button from '../../components/Elements/Button';
import {
    listFAQs,
    retrack as retrackService
} from '../../services/faq';
import {
    mapState,
    mapGetters
} from 'vuex';
import { extractError } from '../../utils/error';
// just one line
export default {
    data() {
        return {
            faqs: {},
            loading: false
        }
    },
    components: {
        Button,
    },
    computed: {
        categories() {
            return Object.keys(this.faqs);
        },
        ...mapState('auth', {
            accountNo: state => state.accountNo
        }),
        ...mapGetters('auth', ['isAdmin'])
    },
    methods: {
        async handleRetrack() {
            try {
                this.loading = true;
                const result = await retrackService(this.accountNo);
                this.loading = false;
                console.log('retrack result : ', result);
                this.$toasted.success('Setup command successful', {
                    duration: 2000
                });
            }
            catch(err) {
                this.loading = false;
                console.log(err);
                const message = extractError(err);
                this.$showError(message);
            }
        },
        processComponent(val, signature) {
            const retrackIdx = val.indexOf(signature);
            const parts = [];
            if(retrackIdx >= 0) {
                parts.push({
                    type: 'string',
                    value: val.substring(0, retrackIdx)
                });
                parts.push({
                    type: 'custom',
                    value: signature
                });
                parts.push({
                    type: 'string',
                    value: val.substring(retrackIdx + signature.length),
                });
                return parts;
            }
            else {
                return [
                    {
                        type: 'string',
                        value: val,
                    }
                ];
            }
            
        },
    },
    async mounted() {
        try {
            this.loading = true;
            const result = await listFAQs();
            this.loading = false;
            const { _embedded: { fAQs } } = result;
            this.faqs = fAQs.map(faq => {
                let finalResult = [];
                const splitResult = this.processComponent(faq.answer, '<retrack/>');
                if(splitResult.length > 1) {
                    const retrackComponent = splitResult[1];
                    const addSplitLeft = this.processComponent(splitResult[0].value, '<add/>');
                    const addSplitRight = this.processComponent(splitResult[2].value, '<add/>');
                    if(addSplitLeft.length > 1) {
                        finalResult = finalResult.concat(addSplitLeft);
                        finalResult.push(retrackComponent);
                        finalResult.push(splitResult[2]);
                    }
                    else if(addSplitRight.length > 1) {
                        finalResult.push(splitResult[0]);
                        finalResult.push(retrackComponent);
                        finalResult = finalResult.concat(addSplitRight);
                    }
                    else finalResult = splitResult;
                }
                return {
                    ...faq,
                    split: finalResult
                };
            });
        }
        catch(err) {
            console.log(err);
        }
    },
}
</script>

<style lang="sass" scoped>
    .wrap
        position: relative
        margin: 0 200px
        top: 30px
        padding: 0 20px

        .title
            margin: 10px 0
            font-family: 'Roboto'
            color: indigo
        
        .active-category
            color: white
            background-image: linear-gradient(225deg, #700875 0%, #8d0b93 50%, #203355 100%)
</style>